import type { FC, PropsWithChildren } from 'react';

import { styled } from 'styled-components';

import { media } from '~/components/shared/core/styles';

const CSSSmallScreenOnlyWrapper = styled.div`
  display: none;

  @media ${({ theme }) => media(theme).lessThan('lg')} {
    display: contents;
  }
`;

export const CSSSmallScreenOnly: FC<PropsWithChildren> = ({ children }) => (
  <CSSSmallScreenOnlyWrapper>{children}</CSSSmallScreenOnlyWrapper>
);
